const env = {
  ID: "prod",
  API_URL: "https://survey.api.nexlabs.app",
  AUTH_API_URL: "https://authentication.api.nexlabs.app",
  GOOGLE_MAP_API_KEY: "AIzaSyDP_hYZ09oQs_8k7Ak9Y7uHjO-PDDbrWpM",
  RECAPTCHA_SITE_KEY: "6LfN594sAAAAADxStkyf5EJ-8JXLMh6YjRzyLQu6",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyAwDtQphORJBhCKDCLCEgyNjTFsuZc3VUc",
    authDomain: "prod-ms-auth.firebaseapp.com",
    projectId: "prod-ms-auth",
    appId: "1:961285256698:web:9ebb2679c5f53319bb6043",
  },
};

export default env;
